import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'address'],

    data() {
        return {
            title: '',
            isLoading: false,
            selectedAddress: null,
            selectedNeighborhood: null,
            buttonName: 'Ažuriraj',
            newName: '',
            newCity: '',
            newRegion: null,
            hasError: '',
            regions: []
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                if(this.address == null){
                    this.title = 'Dodaj adresu'
                    this.buttonName = 'Dodaj'
                }else{
                    this.selectedAddress = this.address;
                    this.selectedNeighborhood = this.address.neighborhood;
                    this.title = 'Izmeni adresu: ' + this.address.name;
                    this.newRegion = this.selectedNeighborhood.name;
                    this.newName = this.address.name;
                    this.newCity = this.address.city;
                }

            }
        },
        newName: function(val, oldVal) {
            this.hasError = '';
        },
        newCity: function(val, oldVal) {
            this.hasError = '';
        },
        selectedNeighborhood: function(val, oldVal) {
            this.hasError = '';
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeEditAddress')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successEditAddress')
        },

        successAdd(){
            this.$topnavbar.$emit('successAddAddress')
        },

        update: update,
        getRegions: getRegions,
        add: add,
        deleteSelectedRegion: deleteSelectedRegion,
        reset: reset,
    },
    beforeMount() {
        this.getRegions();
    },

}

function add() {
    let _self =this;
    const newModel = {
        street: _self.newName,
        city: _self.newCity,
        neighborhoodId: _self.selectedNeighborhood.id
    };
    _self.isLoading = true;
    AdminApiService.createAddress(newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successAdd();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom ažuriranja"
        })
}

function update() {
    if(this.selectedNeighborhood == null ||
        this.newCity.length === 0 ||
        this.newName.length === 0 ) {
        this.hasError = "Molimo popunite ime, grad i region.";
        return;
    }
    if(this.address == null){
        this.add();
        return;
    }
    let _self =this;
    const newModel = {
        street: _self.newName,
        city: _self.newCity,
        neighborhoodId: _self.selectedNeighborhood.id
    };
    _self.isLoading = true;
    AdminApiService.updateAddress(newModel, _self.address.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom ažuriranja"
        })

}

function getRegions() {
    var _self = this;
    AdminApiService.getRegions()
        .then((response) => {
            _self.regions = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function deleteSelectedRegion() {
    this.newRegion = null;
}

function reset() {
    this.newName = '';
    this.newCity = '';
    this.selectedNeighborhood = null;
}





// WEBPACK FOOTER //
// ./src/modals/EditAddressModal.js